export enum CalendarView {
  Mensal = 'mensal',
  Semanal = 'semanal',
  Diario = 'diario',
}

export interface EventoCalendar {
  label: JSX.Element;
}

export interface CalendarLanguage {
  addNew: string;
  daysOfWeek: string[];
  daysOfWeekAbrev?: string[];
  months: string[];
  monthsAbrev: string[];
}

export const ptbrCalendarLanguage: CalendarLanguage = {
  addNew: 'Inserir novo',
  daysOfWeek: [
    'Domingo',
    'Segunda',
    'Terça',
    'Quarta',
    'Quinta',
    'Sexta',
    'Sábado',
  ],
  daysOfWeekAbrev: ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sab'],
  months: [
    'Janeiro',
    'Fevereiro',
    'Março',
    'Abril',
    'Maio',
    'Junho',
    'Julho',
    'Agosto',
    'Setembro',
    'Outubro',
    'Novembro',
    'Dezembro',
  ],
  monthsAbrev: [
    'jan',
    'fev',
    'mar',
    'abr',
    'mai',
    'jun',
    'jul',
    'ago',
    'set',
    'out',
    'nov',
    'dez',
  ],
};

export const ptbrInlineMonthPickerLabelGenerator = (date: Date) =>
  `${ptbrCalendarLanguage.months[date.getMonth()]} de ${date.getFullYear()}`;

/**
 * Retorna os dias da semana (Domingo à Sábado) referentes a data passada
 * @param data Referência
 * @returns
 */
export function getWeekInMonth(data: Date): Date[];

/**
 * Retorna os dias da semana (Domingo à Sábado) referentes ao dia, mês e ano passados.
 * @param dia Dia do Mês (1 a 31)
 * @param mes Mês do ano (0 a 11), onde 0 = Janeiro e 11 = Dezembro
 * @param ano Ano
 * @returns Date[]
 */
export function getWeekInMonth(dia: number, mes: number, ano: number): Date[];

export function getWeekInMonth(diaOuData: Date | number, mes = 0, ano = 0) {
  const arr =
    typeof diaOuData === 'number'
      ? [new Date(ano, mes, diaOuData)]
      : [diaOuData];

  // Dias do mês passado
  while (arr[0].getDay() > 0) {
    arr.unshift(new Date(arr[0].getTime() - 24 * 60 * 60 * 1000));
  }

  // Dias do próximo mês
  while (arr[arr.length - 1].getDay() < 6) {
    arr.push(new Date(arr[arr.length - 1].getTime() + 24 * 60 * 60 * 1000));
  }
  return arr;
}

/**
 * Retorna os dias do mês referêntes à data passada
 * @param data
 */
export function getDaysInMonth(data: Date): Date[];

/**
 * Retorna os dias do mês referêntes ao mês e ano passados
 * @param mes Mês do ano (0 a 11), onde 0 = Janeiro e 11 = Dezembro
 * @param ano Ano
 * @returns Date[]
 */
export function getDaysInMonth(mes: number, ano: number): Date[];

export function getDaysInMonth(mesOuData: Date | number, _ano?: number) {
  const mes = typeof mesOuData === 'number' ? mesOuData : mesOuData.getMonth();
  const ano =
    (typeof mesOuData === 'number' ? _ano : mesOuData.getFullYear()) ?? 0;

  const arr = new Array(31)
    .fill('')
    .map((_, i) => new Date(ano, mes, i + 1))
    .filter((v) => v.getMonth() === mes);

  // Dias do mês passado
  while (arr[0].getDay() > 0) {
    arr.unshift(new Date(arr[0].getTime() - 24 * 60 * 60 * 1000));
  }

  // Dias do próximo mês
  while (arr[arr.length - 1].getDay() < 6) {
    arr.push(new Date(arr[arr.length - 1].getTime() + 24 * 60 * 60 * 1000));
  }
  return arr;
}
